import type { PracticeArea } from '../types/content';

export const practiceAreas: PracticeArea[] = [
  {
    id: 'board-ceo',
    title: 'Board & CEO Search',
    summary:
      'Chair, non-executive director, and chief executive appointments for organizations at moments of transformation.',
    focus: ['Chair and lead independent director', 'Non-executive and advisory board roles', 'Chief executive and managing director', 'CEO succession planning'],
  },
  {
    id: 'c-suite',
    title: 'C-Suite Leadership',
    summary:
      'Enterprise leaders who sit at the top table and translate strategy into measurable results.',
    focus: ['Chief financial officer', 'Chief operating officer', 'Chief technology and digital officer', 'Chief people officer'],
  },
  {
    id: 'functional',
    title: 'Functional Leadership',
    summary:
      'Senior leaders who build and run critical functions across finance, technology, operations, legal, and commercial.',
    focus: ['Finance, risk, and audit', 'Technology, data, and security', 'Commercial, sales, and marketing', 'Legal, compliance, and governance'],
  },
  {
    id: 'interim',
    title: 'Interim Executive Leadership',
    summary:
      'Proven executives deployed quickly to stabilize, transform, or bridge a leadership gap.',
    focus: ['Turnaround and restructuring', 'Transformation programs', 'Post-merger integration', 'Leadership continuity'],
  },
  {
    id: 'assessment',
    title: 'Leadership Assessment',
    summary:
      'Objective evaluation of executive teams and individual leaders against current and future strategy.',
    focus: ['Executive team reviews', 'Internal candidate benchmarking', 'Due diligence for investors', 'Development planning'],
  },
  {
    id: 'succession',
    title: 'Succession Advisory',
    summary:
      'Long-range planning that keeps your organization ready for planned and unplanned leadership change.',
    focus: ['Succession framework design', 'Talent pipeline mapping', 'Emergency succession readiness', 'Board succession reviews'],
  },
];
